import { Label } from '@fluentui/react-components';
import loc from 'owa-localize';
import type { ResourceId } from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { BRANDING_LABEL_ID } from '../../constants/constants';
import { brandingLabel } from '../OwaHeader.scss';
import type { FunctionComponent } from 'react';

const defaultExport: FunctionComponent<{
    label: ResourceId;
}> = observer(function OwaHeaderBrandingLabel({ label }) {
    return (
        <Label id={BRANDING_LABEL_ID} className={brandingLabel} size="large" weight="semibold">
            {loc(label)}
        </Label>
    );
}, 'OwaHeaderBrandingLabel');
export default defaultExport;
